import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GetFaq, DeleteFaq, DetailFaq } from '../../../API/admin'
import Swal from 'sweetalert2'
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'

const Faq = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'FAQ', to: '/faq', active: true }
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const Navigate = useNavigate();
    const [FaqDetail, setFaqDetail] = useState({
        question: '',
        answer: ""
    });
    const [allFaq, setallFaq] = useState([]);
    const [visible, setVisible] = useState(false)
    const [alluser, setUsers] = useState([]);

    useEffect(() => {
        getUserAPI()
    }, [])

    let getUserAPI = async () => {
        let res = await GetFaq()
        console.log(res.data)
        if (res.status) {
            setallFaq(res.data);
        } else {
            setallFaq([]);
        }
    }

    // const HandelChange = (event) => {
    //     // event.preventDefault;
    //     // console.log(event.target.value);
    //     let search = event.target.value;
    //     // console.log("yes");
    //     // let usersarr = Users;
    //     const subArr = alluser.filter(user => (user.fname.includes(search) || (user.corporate_email!=null && user.corporate_email.includes(search)) || user.email.includes(search)) );
    // //   console.log("sub",subArr);
    //   setUsers(subArr);
    //     // callAPI(search);

    // }

    const HandelDelete = async (urlid) => {
        let res = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure , you want to delete this FAQ?",
            // icon: "warning"
        });
        if (res.isConfirmed) {
            let callAPI = async () => {
                let userID = {
                    id: urlid
                }
                console.log(userID);

                let res = await DeleteFaq(userID);
                if (res.status) {
                    enqueueSnackbar("FAQ Deleted successfully", {
                        variant: 'success', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    getUserAPI()
                } else {
                    enqueueSnackbar("Can not delete FAQ", {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    Navigate('/faq')
                }
            }
            callAPI();
        }
    }

    const detailFaq = async (id) => {
        let res = await DetailFaq(id);
        setFaqDetail({
            question: res.data.question,
            answer: res.data.answer
        })
        setVisible(true)
        console.log(res)
    }

    function truncateText(text, maxWords) {
        const words = text.split(' ');
        if (words.length > maxWords) {
            return words.slice(0, maxWords).join(' ') + '...';
        }
        return text;
    }
    return (
        <>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            <CCard className="mb-4">
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h3 className="card-title mb-3">
                                FAQ
                            </h3>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm={3}>

                        </CCol>
                        {/* Select box */}
                        <CCol sm={3}>

                        </CCol>
                        <CCol sm={6} className="d-none d-md-block" >
                            <Link to='/faq/create'>
                                <CButton className='float-end text-white' color="info" >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Add FAQ</CButton>
                            </Link>
                        </CCol>
                    </CRow><br />
                    {/* <MainChart /> */}
                    <CRow
                        xs={{ cols: 1, gutter: 4 }}
                        sm={{ cols: 2 }}
                        lg={{ cols: 4 }}
                        xl={{ cols: 5 }}
                        className="mb-2 text-center custom_scroll_table_scroll"
                    >
                        <CTable striped className=''>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Question</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Answer</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>

                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {allFaq.length === 0 ? (
                                    <tr>
                                        <td colSpan="6">No data found</td>
                                    </tr>
                                ) : (
                                    allFaq.map((entry, index) => (
                                        <CTableRow>
                                            <CTableHeaderCell key={index}>{index + 1}</CTableHeaderCell>
                                            <CTableDataCell key={index}>
                                                <div style={{ maxWidth: "300px" }}>
                                                    {truncateText(entry.question, 8)}
                                                </div>
                                            </CTableDataCell>
                                            <CTableDataCell key={index}>
                                                <div style={{ maxWidth: "300px" }}>
                                                    {truncateText(entry.answer, 8)}
                                                </div>
                                            </CTableDataCell>
                                            <CTableDataCell key={index}>
                                                <div className='d-flex justify-content-center'>
                                                    <CButton className='bi bi-eye-fill text-white admin_btn_space' onClick={(e) => detailFaq(entry.id)} color="primary"></CButton>
                                                    <Link to={`/faq/edit?id=${entry.id}`}>
                                                        <CButton className="bi bi-pencil text-white admin_btn_space" color="warning"></CButton>
                                                    </Link>
                                                    <CButton className='bi bi-trash-fill text-white admin_btn_space' color="danger" onClick={() => HandelDelete(entry.id)}></CButton>
                                                </div>
                                            </CTableDataCell>

                                        </CTableRow>
                                    ))
                                )}
                            </CTableBody>
                        </CTable>
                    </CRow>
                </CCardBody>
            </CCard>

            <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="ScrollingLongContentExampleLabel"
            >
                <CModalHeader>
                    <CModalTitle id="ScrollingLongContentExampleLabel">FAQ</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <h5>Question: </h5>
                    <p className='mb-3'>
                        {FaqDetail.question}
                    </p>
                    <h5> Answer :</h5>
                    <p>
                        {FaqDetail.answer}

                    </p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setVisible(false)}>
                        Close
                    </CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}
export default Faq;